import type {Row} from '@tanstack/react-table';

/**
 * Custom sorting function for date columns (ISO date strings in YYYY-MM-DD format).
 * Handles null/undefined values by pushing them to the end of the list.
 */
export const sortDateColumn = <TData>(
  rowA: Row<TData>,
  rowB: Row<TData>,
  columnId: string
): number => {
  const dateA = rowA.getValue<string | null | undefined>(columnId);
  const dateB = rowB.getValue<string | null | undefined>(columnId);

  // Handle undefined/null - push to end
  if (!dateA && !dateB) return 0;
  if (!dateA) return 1;
  if (!dateB) return -1;

  // String comparison works for YYYY-MM-DD format
  if (dateA < dateB) return -1;
  if (dateA > dateB) return 1;
  return 0;
};
